<template>
  <div id="map-container" style="">
    <div id="fengmap" class="fengmap" />
    <div class="map2"></div>
    <!-- <div class="box"></div> -->
    <!-- <div
      id="cover"
      class="cover"
      :style="{ 'background-color': backgroundColor }"
    /> -->
    <!-- <div id="tools" class="tools"> -->
      <!--楼层切换组件-->
      <!-- <div id="btnsFloor" class="btnsFloor"> -->
        <!--工具控件，2D/3D切换-->
        <!-- <div id="btnsSwitch" class="btnsSwitch"> -->
          <!-- <span :class="planarFlag ? 'planar' : ''" @click="changeMode"> </span> -->
        <!-- </div> -->
        <!--多层/单层切换按钮-->
        <!-- <div class="btnsSwitchViews">
          <span
            :class="multiFlag ? 'changeViews' : ''"
            @click="changeViews"
          ></span>
        </div> -->
        <!--楼层数据-->
        <!-- <ul>
          <li
            v-for="(floor, index) in floors"
            :key="index"
            :class="index === currentFocusGroupIndex ? 'active' : ''"
            @click="changeFloor(floor, index)"
          >
            {{ floor.gname }}
          </li>
        </ul>
      </div>
    </div> -->



  </div>
</template>

<script>
/**
 * setMapNodeColor - 确定node的颜色
 */
import fengmap from "fengmap";
import { get } from "lodash";

export const FENGMAP_MEETING_AREA_TYPE = 210300;
export const FENGMAP_PUBLIC_OFFICE_AREA_TYPE = 340809;
export const FENGMAP_PRIVATE_OFFICE_AREA_TYPE = 340808;
export const FENGMAP_DESK_TYPE = 200501;
export const FENGMAP_SHARED_AREA_TYPE = 294100; // 公共区域

export const FENGMAP_AREA_TYPES = [
  FENGMAP_MEETING_AREA_TYPE,
  FENGMAP_PUBLIC_OFFICE_AREA_TYPE,
  FENGMAP_PRIVATE_OFFICE_AREA_TYPE,
  FENGMAP_SHARED_AREA_TYPE,
];

export const FENGMAP_DESK_TYPES = []; // [FENGMAP_DESK_TYPE]; 如果要显示工位，uncomment

export const DEFAULT_MAP_COLOR = "#333333";
export const NON_RESERVABLE_COLOR = "#333333";

export const MAP_COLORS = {
  public_office: "#EDF6FF",
  private_office: "#F9F4FF",
  shared_area: "#F7F7F7", // 公共区域
  desk: "#9CCBF5",
};

// colors - not used!
export const AREA_COLORS = {
  meeting_room: "CE93D8",
  interview_room: "90CAF9",
};

export const DESK_COLORS = {
  fixed: "FB8C00",
  hot: "7CB342",
  hotel: "039BE5",
};

export default {
  name: "Fengmap",
  props: {
    appKey: {
      type: String,
      default: "",
    },
    appName: {
      type: String,
      default: "",
    },
    defaultMapScale: {
      type: Number,
      default: 1000,
    },
    mapId: {
      type: String,
      default: "",
    },
    areas: {
      type: Array,
      default: () => [],
    },
    desks: {
      type: Array,
      default: () => [],
    },
    backgroundColor: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      loaded: false,
      map: undefined,
      searchAnalyser: undefined,
      currentFocusGroupIndex: 0,
      floors: [],
      planarFlag: true, // 2D
      multiFlag: false, // 是否显示多层
      timer: null
    };
  },
  watch: {
    areas() {
      this.setNodesColor();
    },
  },
  mounted() {
    this.initMap(this.mapId);
  },
  methods: {
    initMap(mapId) {
      if (!mapId) {
        return;
      }
      if (this.map) {
        this.map.dispose();
        this.map = null;
      }
      this.map = new fengmap.FMMap({
        container: document.getElementById("fengmap"),
        appName: this.appName,
        key: this.appKey,
        defaultViewMode: fengmap.FMViewMode.MODE_3D,
        // defaultBackgroundColor: "rgba(13, 47, 124, 0.1)",
        // defaultVisibleGroups: [1, 2],
        // mapThemeURL: "/assets/floormap/themes",
        // 设置主题
        defaultThemeName: "1505856605834289154",
        defaultControlsPose: 360,
        focusAlpha: 0.3,
        defaultBackgroundAlpha:0,
        // focusAnimateMode: false,            //开启聚焦层切换的动画显示
        // defaultBackgroundAlpha:1,
        defaultMapScale:260, // 默认自定义比例尺为 1：100（厘米）
        maxTitleAngle:90
      });
      const _this = this;
      this.map.openMapById(mapId, function (error) {
        alert("Failed to open map:", error);
      });
      // 全凭设置
      // this.map.fullScreen(true)
      // 地图缩放比例
      this.map.mapScale(10)
      // 注册事件
      this.map.on("loadComplete", function () {
        console.log(
          mapId + " map load completed.",
          _this.map.groupIDs,
          _this.map.listGroups
        );
        _this.map.focusGroupID =
          _this.map.groupIDs[_this.currentFocusGroupIndex];
        _this.loaded = true;
        // _this.searchAnalyser = new fengmap.FMSearchAnalyser(_this.map)
        _this.setNodesColor();
        _this.timer = setInterval(() => _this.rotateFocusGroup(), 60000);
        if (_this.map != null) {
          _this.map.setBackgroundColor(this.backgroundColor);
        }
        _this.floors = _this.map.listGroups;
      });
      return this.map;
    },
    destroyMap() {
      if (!this.map) {
        return;
      }

      try {
        this.map.dispose();
        this.map = null;
      } catch (err) {
        console.warn(err);
      }
    },

    rotateFocusGroup() {
      if (this.map) {
        const nextFocusGroupIndex =
          (this.currentFocusGroupIndex + 1) % this.map.groupIDs.length;
        this.map.focusGroupID = this.map.groupIDs[nextFocusGroupIndex];
        this.currentFocusGroupIndex = nextFocusGroupIndex;
        // this.setNodesColor();
      }
    },

    /**
     * 根据参数信息进行搜索
     * keyword: 搜索关键字
     * groupID: 楼层id，默认为'all': 所有楼层
     * typeID：根据设置条件返回精确匹配结果集，支持多个typeID同时查询，如：[170000,200000]
     * nodeType: fengmap.FMNodeType, 如 'model'
     * fid: 模型FID,整个建筑内唯一ID。
     * */
    searchByParams(params) {
      if (this.map == null) {
        return;
      }

      /**
       * fengmap.FMSearchRequest 是可设置查询类型，查询关键字的请求类
       * https://developer.fengmap.com/docs/js/v2.7.0/fengmap.FMSearchRequest.html
       * */
      var searchRequest = new fengmap.FMSearchRequest();

      // 配置keyword参数
      if (params.keyword && params.keyword !== "") {
        searchRequest.keyword = params.keyword;
      }

      // 配置groupID参数
      if (params.groupID) {
        searchRequest.groupID = params.groupID;
      }

      // 配置FID参数
      if (params.FID) {
        searchRequest.FID = params.FID;
      }
      // 配置typeID参数
      if (params.typeID != null) {
        searchRequest.typeID = params.typeID;
      }

      // 配置nodeType参数
      if (params.nodeType != null) {
        searchRequest.nodeType = params.nodeType;
      }

      /*
          //设置模糊搜索的语言类型，只针对keyword类型的搜索
          searchRequest.keywordLanguageTypes([fengmap.FMLanguageType.EN,fengmap.FMLanguageType.ZH]);
          */

      /* //周边查询
        searchRequest.circle = {
            //查询范围中心点坐标
            center: {
                x: map.center.x,
                y: map.center.y
            },
            radius: 50  //查询范围半径
        }; */

      /**
       * 根据请求对象查询分析方法
       * https://developer.fengmap.com/docs/js/v2.7.0/fengmap.FMSearchAnalyser.html#getQueryResult
       * */
      var sortRes = this.searchAnalyser.getQueryResult(searchRequest, [
        "SINGLE",
      ]);

      return sortRes;
    },

    /**
     * 根据FID搜索地图Model
     * fid: FID
     * */
    findModelByFid(fid, moveToFirst = true) {
      const params = {};
      params.FID = fid;
      params.nodeType = fengmap.FMNodeType.MODEL;
      const result = this.searchByParams(params);

      if (result.length > 0 && moveToFirst) {
        const model = result[0];
        // 打印model信息
        // console.log('选中model信息', model);
        if (model != null) {
          // 视野中心移动到指定位置,如果不是当前聚焦层，将先设置目标层为聚焦层在跳转
          const coordinate = {
            x: model.mapCoord.x,
            y: model.mapCoord.y,
            groupID: model.groupID,
          };
          this.map.moveTo(coordinate);

          // 添加marker
          // addMarkers(model);
        }
      }
    },

    /**
     * 根据分类ID搜索地图数据
     * */
    searchByTypeID(typeID) {
      // 调用搜索方法
      const params = {};
      params.groupID = this.map.focusGroupID; // 当前聚焦楼层
      params.typeID = typeID;
      params.nodeType = fengmap.FMNodeType.MODEL;
      const result = this.searchByParams(params);
      return result;
    },

    getDeskColor(area) {
      if (area.disabled) {
        return "#F7F7F7";
      } else if (area.reservation) {
        return "#FF7558";
      } else {
        return "#77FF97";
      }
    },

    setMapNodeColor(node, item = null) {
      if (!node) {
        return;
      }
      // console.log('---------------node.FID', node.FID);
      if ([FENGMAP_MEETING_AREA_TYPE].includes(node.typeID)) {
        const area = item || this.areas.find((x) => x.map_id === node.FID);
        if (area) {
          if (!area.is_reservable) {
            const color = NON_RESERVABLE_COLOR;
            node.setColor(color);
            node.setStrokeColor(color);
          } else {
            const color = get(area, "statusBag.reservedStatus.color");
            node.setColor(color);
            node.setStrokeColor(color);
          }
        } else {
          node.setColor(DEFAULT_MAP_COLOR);
          node.setStrokeColor(DEFAULT_MAP_COLOR);
        }
      } else if (FENGMAP_DESK_TYPES.includes(node.typeID)) {
        const desk = item || this.desks.find((x) => x.map_id === node.FID);
        if (desk && ["hot", "hotel"].includes(desk.desk_type)) {
          const color = this.getDeskColor(desk);
          node.setColor(color);
          node.setStrokeColor(color);
        } else {
          node.setColor(DEFAULT_MAP_COLOR);
          node.setStrokeColor(DEFAULT_MAP_COLOR);
        }
      } else {
        // 保留theme原来的颜色
        // node.setColor(DEFAULT_MAP_COLOR);
        // node.setStrokeColor(DEFAULT_MAP_COLOR);
      }
    },

    /**
     * set nodes color according to needs
     * @param {string} layer 'model', 'textLayer', see fengmap docs
     */
    setNodesColor(layer = "model") {
      const _this = this;
      if (this.loaded) {
        this.map.groupIDs.forEach((groupID) => {
          const group = this.map.getFMGroup(groupID);
          group.traverseByAlias(layer, function (node) {
            _this.setMapNodeColor(node);
          });
        });
      }
    },

    changeViews() {
      //切换地图单层-false/多层展示-true
      this.multiFlag = !this.multiFlag;
      //设置单/多楼层切换
      this.map.showSingerOrMultiGroup(this.multiFlag);
    },

    changeMode() {
      if (this.planarFlag) {
        //切换地图为三维模式
        if (this.map) {
          this.map.viewMode = fengmap.FMViewMode.MODE_3D;
        }
      } else {
        //切换地图为二维模式
        if (this.map) {
          this.map.viewMode = fengmap.FMViewMode.MODE_2D;
        }
      }
      //更改状态
      this.planarFlag = !this.planarFlag;
    },

    changeFloor(floor, index) {
      clearInterval(this.timer)
      this.timer = setInterval(() => this.rotateFocusGroup(), 60000);
      if (this.map) {
        //设置地图显示楼层
        if (this.multiFlag) {
          //展示全部楼层
          this.map.visibleGroupIDs = this.map.groupIDs;
        } else {
          //展示单个楼层
          this.map.visibleGroupIDs = [floor.gid];
        }
        //设置地图聚焦楼层
        this.map.focusGroupID = floor.gid;

        //更新选中楼层id及索引
        // defaultFocusID = floorId;
        this.currentFocusGroupIndex = index;
      }
    },
  },
};
</script>

<style lang="less">
#map-container {
  width: 100%;
  height: 100%;
  position: relative;
   .map2{
     position: absolute;
     width: 100px;
     height: 40px;
     right: 0px;
     bottom: 0px;
     background:rgb(7, 41, 122);
     box-shadow: #083b78;
   }
  .fengmap {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cover {
    position: absolute;
    background-color: red;
    bottom: 0;
    right: 0;
    width: 150px;
    height: 35px;
  }

  /* 自定义工具控件 */
  .tools {
    width: 40px;
    position: absolute;
    left: 30px;
    bottom: 32px;
    background: rgba(79, 134, 198, 0.3);
  }

  .btnsFloor {
    // display: block;
    // -moz-box-shadow: 10px 10px 5px #888888;
    /* 老的 Firefox */
    // box-shadow: 2px 2px 2px #888888;
    // background-color: #fff;
  }
  .btnsFloor .btnsSwitchViews span {
    display: block;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    background: url("/assets/floormap/single.png") no-repeat center;
  }
  .btnsFloor .btnsSwitchViews span.changeViews {
    background: url("/assets/floormap/double.png") no-repeat center;
  }

  .btnsFloor ul {
    width: 100%;
    list-style-type: none;
    display: inline;
    padding: 0;
  }

  .btnsFloor ul li {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    // border-bottom: 1px solid #eee;
  }

  .btnsFloor ul li.active {
    color: #fff;
    background-color: #1e82fa;
    border-bottom: 1px solid #1e82fa;
  }

  .btnsSwitch {
    width: 40px;
    // display: block;
    // position: absolute;
    // left: 80px;
    // top: 20px;
    // -moz-box-shadow: 10px 10px 5px #888888;
    /* 老的 Firefox */
    // box-shadow: 2px 2px 2px #888888;
  }

  .btnsSwitch span {
    display: block;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    background: url("/assets/floormap/3D.png") center center no-repeat;
  }

  .btnsSwitch span.planar {
    background: url("/assets/floormap/2D.png") center center no-repeat;
  }

  .btnsSwitch,
  .btnsSwitchViews,
  ul li {
    position: relative;
  }

  .btnsSwitch span::after,
  .btnsSwitchViews span::after,
  ul li:not(:last-child)::after {
    content: "";
    display: inline-block;
    width: 30px;
    position: absolute;
    right: 5px;
    bottom: 0;
    border-bottom: 1px solid rgba(232, 232, 232, 0.2);
  }
}
</style>
